// extracted by mini-css-extract-plugin
module.exports = {"FooterForHome":"footer_FooterForHome__28M4u","FooterForGlobal":"footer_FooterForGlobal__3HDmo"};